import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'grid',
    gap: theme.spacing(3),
  },
  sectionTitle: {
    fontWeight: 700,
    marginBottom: theme.spacing(1),
  },
  list: {
    margin: 0,
    paddingLeft: theme.spacing(3),
  },
  note: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
  },
  numberValue: {
    fontWeight: 500,
  },
}));

export default useStyles;
